/**
 * Supplies — one page for every scope.
 *
 * National supply posture, or one region's restock and par levels.
 *
 * The two bodies are the pages that used to live under `/admin/supplies` and
 * `/r/:regionSlug/supplies`. Neither has changed: at national scope this calls
 * the `/dashboards/admin/…` endpoint the admin page called, and at regional
 * scope the `/dashboards/regional/:slug/…` endpoint the regional page called,
 * so the numbers are the same numbers. What is gone is the second URL tree and
 * the second copy of the chrome around them.
 */
import { DashboardsPage } from '../DashboardsPage';
import { RegionalSupplies } from '../regional/RegionalSupplies';

import AdminSupplies from './AdminSupplies';
import { useDashboardScope } from './dashboard-scope';
import { DashboardScopeHeader } from './DashboardScopeHeader';
import { ScopedDashboardBody } from './ScopedDashboardBody';

export default function SuppliesPage() {
  const scope = useDashboardScope();

  return (
    <DashboardsPage
      header={<DashboardScopeHeader title="Supplies" basePath="/admin/supplies" scope={scope} />}
    >
      <ScopedDashboardBody
        scope={scope}
        national={<AdminSupplies />}
        regional={(regionSlug) => <RegionalSupplies regionSlug={regionSlug} />}
      />
    </DashboardsPage>
  );
}
